import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-final-form";
import { UiTableHeaderSearchProps } from "../../../models/components/table/table-search.model";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

const UiTableHeaderSearch = (props: UiTableHeaderSearchProps) => {
	const { t } = useTranslation("common");

	const [formData, setFormData] = useState<{ search: string | null }>({
		search: props.value ?? null,
	});

	const handleChange = (value: string | null): void => {
		setFormData({ ...formData, search: value });
		if (!value) props.searchFn(value);
	};

	const handleSubmit = (data: { search: string }, form: any) => {
		// Ignore Enter/submit while search is in flight
		if (!props.isLoading) {
			props.searchFn(data.search);
		}
	};

	const handleButtonClick = (e: React.MouseEvent) => {
		e.preventDefault();
		// Ignore button click while search is in flight
		if (!props.isLoading) {
			props.searchFn(formData.search);
		}
	};

	return (
		<div className="k-searchbar">
			<Form
				onSubmit={handleSubmit}
				initialValues={formData as Partial<{ search: string }>}
				render={({ handleSubmit, form, submitting, pristine, values }) => (
					<form onSubmit={props.isLoading ? (e) => e.preventDefault() : handleSubmit}>
						<div className="p-inputgroup">
							<InputText
								id="search"
								placeholder={t(props.placeholder)}
								name="search"
								value={formData.search || undefined}
								className="search-input"
								onChange={(e) => handleChange(e.target.value)}
							/>
							<Button
								icon="pi pi-search"
								className=""
								onClick={handleButtonClick}
								disabled={props.isLoading}
								loading={props.isLoading}
							/>
						</div>
						{props.helperText && (
							<small
								className="p-error"
								style={{ display: "block", marginTop: "0.25rem" }}
							>
								{props.helperText}
							</small>
						)}
					</form>
				)}
			/>
		</div>
	);
};

export default UiTableHeaderSearch;
